<template>
  <base-modal :box="box" :step="step" :body_class="['pb-0']" @on-back="mixin_set_init_step">
    <number-create-form ref="form" @submit.native.prevent="save" />

    <i-button slot="footer-ok" size="large" type="success" :loading="is_loading" @click="save">
      {{ $t('pbx.worksheet.modal.action.child.button.ok') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '../../../_base/index';
  import { StepMixin } from '../../../_base/step-mixin';
  import NumberCreateForm from '@pbx/components/numbers/form/create';

  export default {
    components: { BaseModal, NumberCreateForm },
    mixins: [StepMixin],

    data() {
      return {
        is_loading: false
      };
    },

    methods: {
      save: function() {
        const form = this.$refs.form;

        form.validate().then(is_valid => {
          if (is_valid) {
            this.is_loading = true;
            form
              .send()
              .then(number => {
                this.mixin_save_step({ params: { number_id: number.id } });
                this.mixin_set_init_step();
              })
              .catch(e => this.$noty.server_error(e))
              .finally(() => (this.is_loading = false));
          }
        });
      }
    }
  };
</script>
